import { useEffect, useState } from 'react';

interface CountdownResult {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  fechaLabel: string;
  horaLabel: string;
}

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export function useCountdown(targetIso: string): CountdownResult {
  const target = new Date(targetIso);

  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const diff = Math.max(0, target.getTime() - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor(diff / 3600000) % 24;
  const minutes = Math.floor(diff / 60000) % 60;
  const seconds = Math.floor(diff / 1000) % 60;

  const fechaLabel = isNaN(target.getTime())
    ? ''
    : capitalize(target.toLocaleDateString('es-PE', { weekday: 'long', day: 'numeric', month: 'long' }));
  const horaLabel = isNaN(target.getTime())
    ? ''
    : target.toLocaleTimeString('es-PE', { hour: 'numeric', minute: '2-digit', hour12: true });

  return { days, hours, minutes, seconds, fechaLabel, horaLabel };
}
